var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 2.66659C5.05452 2.66659 2.66671 5.0544 2.66671 7.99992C2.66671 10.9454 5.05452 13.3333 8.00004 13.3333C10.9456 13.3333 13.3334 10.9454 13.3334 7.99992C13.3334 5.0544 10.9456 2.66659 8.00004 2.66659ZM1.33337 7.99992C1.33337 4.31802 4.31814 1.33325 8.00004 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00004 14.6666C4.31814 14.6666 1.33337 11.6818 1.33337 7.99992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13807 5.52851C9.39842 5.78886 9.39842 6.21097 9.13807 6.47132L7.60948 7.99992L9.13807 9.52851C9.39842 9.78886 9.39842 10.211 9.13807 10.4713C8.87772 10.7317 8.45561 10.7317 8.19526 10.4713L6.19526 8.47132C5.93491 8.21097 5.93491 7.78886 6.19526 7.52851L8.19526 5.52851C8.45561 5.26816 8.87772 5.26816 9.13807 5.52851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/left-chevron.adaeb943.svg";
export { ForwardRef as ReactComponent };